<script>
	import * as Dialog from '$lib/components/ui/dialog';
	export let body_class = 'max-w-[min(992px,92%)]';
	export let desc_class = 'p-8 max-lg:p-4';
</script>

<Dialog.Root>
	<Dialog.Trigger>
		<slot name="trigger" />
	</Dialog.Trigger>
	<Dialog.Content class="dialog border-[0px] {body_class}  p-0 " data-lenis-prevent>
		<Dialog.Header>
			<Dialog.Description
				class="text-[rgba(0,0,0,0.7)]  max-h-[80vh] {desc_class} overflow-y-scroll pointer-events-auto"
			>
				<slot name="body" class="w-full" />
			</Dialog.Description>
		</Dialog.Header>
	</Dialog.Content>
</Dialog.Root>

<style>
	:global(.dialog button:not(.plyr button):not(.splide__arrow)) {
		position: absolute;
		right: -10px;
		top: -10px;
		background: linear-gradient(90deg, #f6eb14 -55.71%, #f8991d 272.14%);
		opacity: 100%;
		border-radius: 50%;
		width: 40px;
		height: 40px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	:global(.dialog button:not(.splide__arrow)) {
		background: linear-gradient(90deg, #f6eb14 -55.71%, #f7c518 272.14%);
	}
	:global(.dialog button:focus) {
		box-shadow: none;
	}
</style>
